function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _pt from "prop-types";
var _excluded = ["id", "className", "type", "noWrap", "truncate", "ariaHidden", "align", "tag", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import classNames from 'classnames';
import "./heading.css";
export var Heading = function Heading(_ref) {
  var id = _ref.id,
    className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'h1' : _ref$type,
    _ref$noWrap = _ref.noWrap,
    noWrap = _ref$noWrap === void 0 ? false : _ref$noWrap,
    _ref$truncate = _ref.truncate,
    truncate = _ref$truncate === void 0 ? false : _ref$truncate,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'inherit' : _ref$align,
    tag = _ref.tag,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var typeClass = type && type.slice(1).replace('-', '--');
  var typeEl = tag || type && type.substring(0, 2);
  var typeNum = type && type.substring(1, 2);
  var Tag = typeEl;
  var classes = classNames('lm-Heading', _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "lm-Heading".concat(typeNum), true), 'lm-Heading6--small', type && type.includes('h6-small-')), 'lm-Heading1--large', type && type.includes('h1-large-')), "lm-Heading".concat(typeClass), typeClass), "lm-typography-align-".concat(align), align), 'lm-typography-no-wrap', noWrap), 'lm-typography-truncate', truncate), className);
  return /*#__PURE__*/React.createElement(Tag, _extends({
    id: id,
    className: classes,
    "aria-hidden": ariaHidden ? 'true' : undefined
  }, otherProps), children);
};
Heading.propTypes = {
  /** Add an optional ID to the element with the class `lm-Heading`. This is a good use case for jump links */id: _pt.string,
  /** Add custom classes to in the element with the class `lm-Heading`. */className: _pt.string,
  /** Determine the semantic Heading level and styling.
     * @default 'h1'
     */
  type: _pt.oneOf(['h1-large', 'h1-large-bold', 'h1', 'h1-bold', 'h2', 'h2-medium', 'h2-bold', 'h2-light', 'h3', 'h3-medium', 'h3-bold', 'h3-light', 'h4', 'h4-medium', 'h4-bold', 'h4-light', 'h5', 'h5-medium', 'h5-light', 'h5-bold', 'h6', 'h6-medium', 'h6-bold', 'h6-small', 'h6-small-medium', 'h6-small-bold']),
  /** Prevent the heading from wrapping if the length exceeds the width of the containing element.
     * @default false
     */
  noWrap: _pt.bool,
  /** Truncate the heading with an ellipsis if the length exceeds the width of the containing element.
     * @default false
     */
  truncate: _pt.bool,
  /** Hide the element from screen readers.
     * @default false
     */
  ariaHidden: _pt.bool,
  /** Align heading text (does not work when using tag="span").
     * @default 'inherit'
     */
  align: _pt.oneOf(['inherit', 'left', 'center', 'right']),
  /** Allow output HTML tag to be specified independent from style type.
     */
  tag: _pt.oneOf(['span', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  /**
     * Children are rendered in the element with the class `lm-Heading`. >
     */
  children: _pt.node
};